import { downloadBlobFromResponse, getCsrfValue } from "~/api/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export const downloadFreeCapacityPushSalesCoverage = () => {
  const url = resolveApiUrl(`/api/fcc/download/salescoverage`);

  return fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "GET",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};

export const downloadFreeCapacityPushScope = () => {
  const url = resolveApiUrl(`/api/fcc/download/fccscope`);

  return fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "GET",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
